import { useCallback, useEffect, useState } from 'react';
import { Balance,useGetBalanceQuery } from '@api/apiCompat';

export const useBalance = () => {
  const [skipQuery, setSkipQuery] = useState(false);
  const { data, isLoading, error, refetch } = useGetBalanceQuery(undefined, {
    skip: skipQuery,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    refetchOnMountOrArgChange: true,
    pollingInterval: 30000, // Poll every 30s to catch background token changes (scraper completions)
  });

  useEffect(() => {
    // Stop retrying on 403, 404 or 500 errors
    if (error && typeof error === 'object' && 'status' in error) {
      const {status} = (error as any);
      if (status === 403 || status === 404 || status === 500) {
        setSkipQuery(true);
      }
    }
  }, [error]);

  // Return zero balance on error - don't show fake values
  const defaultBalance: Balance = {
    balance: 0,
    token: 0,
    reserved: 0,
  };

  // Cast the response to Balance type since OpenAPI schema doesn't define it properly
  const balanceData: Balance | undefined = error ? defaultBalance : (data as Balance | undefined);

  // Expose refetch for manual balance refresh after mutations
  const refreshBalance = useCallback(() => {
    if (!skipQuery) {
      refetch();
    }
  }, [skipQuery, refetch]);

  return {
    data: balanceData,
    isLoading,
    error: skipQuery ? null : error,
    refetch: refreshBalance,
  };
};
